import { join as _join } from '@lodash';
import DateUtils from '@utils/date/DateUtils';

export default class SpecialsRequest {
    public specialIds?: string;
    public startDate?: string;
    public endDate?: string;
    public status?: string;
    public results?: number;

    constructor(props: SpecialsRequest) {
        Object.assign(this, props);
    }

    public toString() {
        return JSON.stringify(this);
    }

    // =============================
    // Rest requests
    // =============================

    static createSpecialsResultsRequest(startDate: Date, endDate: Date): SpecialsRequest {
        return new SpecialsRequest({
            status: 'finished',
            results: 1,
            startDate: DateUtils.toString(DateUtils.inUtcTime(startDate)),
            endDate: DateUtils.toString(DateUtils.inUtcTime(endDate)),
        });
    }

    static createSpecialsDetailsRequest(specialIds: number[]): SpecialsRequest {
        return new SpecialsRequest({
            specialIds: _join(specialIds, ','),
        });
    }

    static createSpecialOfferRequest(startDate: Date, endDate: Date): SpecialsRequest {
        return new SpecialsRequest({
            results: 1,
            startDate: DateUtils.toString(DateUtils.inUtcTime(startDate)),
            endDate: DateUtils.toString(DateUtils.inUtcTime(endDate)),
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/specials/_private/SpecialsRequest.ts